import { Box, Text } from '@rsos/base-components';
import type { KeywordSet } from '@rsos/reduxDataStore';
import { KeywordRow } from './KeywordRow/KeywordRow';
import {
  StyledHeaderRow,
  StyledHeading,
  StyledTable,
} from './KeywordTable.styles';

export const KeywordTable = ({
  keywordSets,
}: {
  keywordSets: KeywordSet[];
}) => {
  return (
    <StyledTable>
      {keywordSets.length === 0 ? (
        <Box p="48px 36px">
          <Text color="secondaryText" textAlign="center">
            No keywords are currently being listened for;
            <br />
            add a new keyword to get started.
          </Text>
        </Box>
      ) : (
        <>
          <StyledHeaderRow>
            <StyledHeading>
              <Text size="xsmall" fontWeight="bold">
                Topic
              </Text>
            </StyledHeading>
            <StyledHeading>
              <Text size="xsmall" fontWeight="bold">
                Tier
              </Text>
            </StyledHeading>
            <StyledHeading>
              <Text size="xsmall" fontWeight="bold">
                Keyword Terms
              </Text>
            </StyledHeading>
            <StyledHeading>
              <Text size="xsmall" fontWeight="bold">
                Speaker
              </Text>
            </StyledHeading>
            <StyledHeading>{/* Edit */}</StyledHeading>
            <StyledHeading>{/* Elipsis Menu */}</StyledHeading>
          </StyledHeaderRow>
          {keywordSets.map(set => (
            <KeywordRow key={set.id} keywordSet={set} />
          ))}
        </>
      )}
    </StyledTable>
  );
};
